import {
    PROFILE_ERROR,
    PROFILE_SUCCESS,
    EDIT_PROFILE,
    RESET_PROFILE_FLAG,
    UPDATE_PASSWORD,
    UPDATE_PHONE_NUMBER,
    UPDATE_USER_DETAILS,
    UPDATE_USER_PROFILE_PICTURE,
    UPDATE_USER_PROFILE_PICTURE_SUCCESS,
    UPDATE_USER_PROFILE_PICTURE_ERROR,
    UPDATE_TWO_FACTOR_AUTH,
    UPDATE_TWO_FACTOR_AUTH_SUCCESS,
    UPDATE_TWO_FACTOR_AUTH_ERROR,
    UPDATE_ORG_LOGO_SUCCESS,
    UPDATE_ORG_LOGO,
    UPDATE_ORG_LOGO_FAIL
} from "./actionTypes"

export const editProfile = user => {
  return {
    type: EDIT_PROFILE,
    payload: { user },
  }
}

export const profileSuccess = msg => {
  return {
    type: PROFILE_SUCCESS,
    payload: msg,
  }
}

export const profileError = error => {
  return {
    type: PROFILE_ERROR,
    payload: error,
  }
}

export const resetProfileFlag = error => {
  return {
    type: RESET_PROFILE_FLAG,
  }
}

export const updatePassword = data => {
  return {
    type: UPDATE_PASSWORD,
    payload: { data }
  }
}
export const updatePhoneNumber = (phone_number) => {
  return {
    type: UPDATE_PHONE_NUMBER,
    payload: { phone_number }
  }
}

export const updateUserDetails = (name, phone_number) => {
  return {
    type: UPDATE_USER_DETAILS,
    payload: { name, phone_number }
  }
}

export const updateUserProfilePicture = (data) => {
    return {
        type: UPDATE_USER_PROFILE_PICTURE,
        payload: { data }
    }
}

export const updateUserProfilePictureSuccess = (msg) => {
    return {
        type: UPDATE_USER_PROFILE_PICTURE_SUCCESS,
        payload: msg
    }
}

export const updateUserProfilePictureError = (error) => {
    return {
        type: UPDATE_USER_PROFILE_PICTURE_ERROR,
        payload: error
    }
}

export const updateOrgLogo = (data) => {
    return {
        type:UPDATE_ORG_LOGO,
        payload:{data}
    }
}

export const updateOrgLogoSuccess = (msg) => {
    return {
        type: UPDATE_ORG_LOGO_SUCCESS,
        payload: msg
    }
}

export const updateOrgLogoFail= (error) => {
    return {
        type: UPDATE_ORG_LOGO_FAIL,
        payload: error
    }
}

export const updateTwoFactorAuth = (data) => {
    return {
        type: UPDATE_TWO_FACTOR_AUTH,
        payload: { data }
    }
}

export const updateTwoFactorAuthSuccess = (msg) => {
    return {
        type: UPDATE_TWO_FACTOR_AUTH_SUCCESS,
        payload: msg
    }
}

export const updateTwoFactorAuthError = (error) => {
    return {
        type: UPDATE_TWO_FACTOR_AUTH_ERROR,
        payload: error
    }
}
